import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Applications/index.tsx");
